import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Label } from 'reactstrap'
import { convert, getTypes, findUnitsByTypes, findUnitByName, findMeshUnits } from '../../../formulas/unitConverter';

export default class UnitConverterForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dropDownOpen: false
        }
    }

    /** Initialisation de l'ensemble du formulaire */
    componentDidMount = () => {
        const unitTypes = getTypes() // On récupère tous les types d'unité
        const unitsForType = findUnitsByTypes(unitTypes[0]) // On récupère les unités pour le premier type
        const value1 = 1
        const unit1 = unitsForType[0]
        const unit2 = unitsForType[1]
        const value2 = convert(value1, unit1, unit2)
        this.props.formToState({ value1, value2, unit1, unit2, ready: true, unitTypes, unitsForType, unitType: unitTypes[0] }) // Redux
    }

    toggleDropDown = () => {
        this.setState({ dropDownOpen: !this.state.dropDownOpen })
    }

    /** Fonction de conversion d'une unité 
     * appellée lors d'une modification des inputs
    */
    convertFunction = (e) => {
        const target = e.target
        try {
            const parsedValue = parseFloat(target.value)
            if (parsedValue) {
                switch (target.name) {
                    case "value1":
                        const value2 = convert(parsedValue, this.props.unitConverterValues.unit1, this.props.unitConverterValues.unit2)
                        this.props.formToState({ value2, value1: parsedValue })
                        break
                    case "value2":
                        const value1 = convert(parsedValue, this.props.unitConverterValues.unit2, this.props.unitConverterValues.unit1)
                        this.props.formToState({ value1, value2: parsedValue })
                        break
                    default:
                        break
                }
            } else {
                // The parsedValue is NaN => the reason is probably that user is trying to set a negative value
                switch (target.name) {
                    case "value1":
                        this.props.formToState({ value2: '', value1: target.value })
                        break
                    case "value2":
                        this.props.formToState({ value1: '', value2: target.value })
                        break
                    default:
                        break
                }
            }
        } catch (error) {
            // There was probably a parsing to float error
            console.log(error)
        }
    }

    /** Fonction actualisant la vue pour un changement de type d'unité */
    changeUnitType = (e) => {
        const target = e.target
        const unitType = target.value
        switch (unitType) {
            case "Mesh size":
                const meshUnits = findMeshUnits()
                // Ici pas de "unit1" ni "unit2", les valeurs et types sont prédéfinis !
                const usMesh = meshUnits[0]["US"]
                const mmMesh = meshUnits[0]["mm"]
                this.props.formToState({ meshUnits, usMesh, mmMesh, unitType })
                break
            default:
                const unitsForType = findUnitsByTypes(unitType)
                const unit1 = unitsForType[0]
                const unit2 = unitsForType[1]
                const value2 = convert(this.props.unitConverterValues.value1, unit1, unit2)
                this.props.formToState({ unit1, unit2, unitType, unitsForType, value2 }) // Redux
                break
        }

    }

    /** Méthode de changement d'une unité (ex: mètre) dans les deux dropdown */
    changeUnit = (e) => {
        const target = e.target
        const newUnit = findUnitByName(target.value)
        let value2 = 0
        if (target.name === "unit1") {
            if (newUnit.name === this.props.unitConverterValues.unit2.name) {
                // Cas où on doit échanger les deux unités
                value2 = convert(this.props.unitConverterValues.value1, this.props.unitConverterValues.unit2, this.props.unitConverterValues.unit1)
                this.props.formToState({ unit1: this.props.unitConverterValues.unit2, unit2: this.props.unitConverterValues.unit1, value2 })
            } else {
                value2 = convert(this.props.unitConverterValues.value1, newUnit, this.props.unitConverterValues.unit2)
                this.props.formToState({ [e.target.name]: newUnit, value2 }) // Redux
            }
        } else if (target.name === "unit2") {
            if (newUnit.name === this.props.unitConverterValues.unit1.name) {
                // Cas où on doit échanger les deux unités
                value2 = convert(this.props.unitConverterValues.value1, this.props.unitConverterValues.unit2, this.props.unitConverterValues.unit1)
                this.props.formToState({ unit1: this.props.unitConverterValues.unit2, unit2: this.props.unitConverterValues.unit1, value2 })
            } else {
                value2 = convert(this.props.unitConverterValues.value1, this.props.unitConverterValues.unit1, newUnit)
                this.props.formToState({ [e.target.name]: newUnit, value2 }) // Redux
            }
        }
    }

    changeMeshValue = (e) => {
        const target = e.target
        let unitName = ''
        let u2Name = ''
        if (target.name === "usMesh") {
            unitName = "US"
            u2Name = 'mmMesh'
        } else {
            unitName = "mm"
            u2Name = 'usMesh'
        }
        const conversion = convert(parseFloat(target.value), { name: unitName, type: "Mesh size" })
        this.props.formToState({ [target.name]: parseFloat(target.value), [u2Name]: conversion })
    }

    render() {
        return (
            <Form className="unit-converter-form">
                {this.props.unitConverterValues.ready ?
                    <div>
                        {/** UNIT TYPE */}
                        <select className="form-control" onChange={this.changeUnitType}>
                            {this.props.unitConverterValues.unitTypes.map((type, key) => {
                                return (<option key={key} value={type}>{type}</option>)
                            })}
                        </select>
                        <br />
                        {/** UNIT 1 AND 2 */}
                        {this.props.unitConverterValues.unitType === "Mesh size" ?
                            <div className="row">
                                <div className="col-md-6">
                                    <Label for="usMesh">US Standard</Label>
                                    <Input name="usMesh" type="select" onChange={this.changeMeshValue} value={this.props.unitConverterValues.usMesh}>
                                        {this.props.unitConverterValues.meshUnits.map((mu, i) => (
                                            <option key={i} value={mu["US"]}>{mu["US"]}</option>
                                        ))}
                                    </Input>
                                </div>
                                <div className="col-md-6">
                                    <Label for="mmMesh">mm</Label>
                                    <Input name="mmMesh" type="select" onChange={this.changeMeshValue} value={this.props.unitConverterValues.mmMesh}>
                                        {this.props.unitConverterValues.meshUnits.map((mu, i) => (
                                            <option key={i} value={mu["mm"]}>{mu["mm"]}</option>
                                        ))}
                                    </Input>
                                </div>
                            </div>
                            :
                            <div className="row">
                                <div className="col-md-6">
                                    <div>
                                        <Input name="value1" step={0.0000000000000000001} value={this.props.unitConverterValues.value1} onChange={this.convertFunction} />
                                        <select value={this.props.unitConverterValues.unit1.name} id="unit1" name="unit1" className="form-control" onChange={this.changeUnit}>
                                            {this.props.unitConverterValues.unitsForType.map((unit, key) => {
                                                return (<option key={key} value={unit.name}>{unit.name}</option>)
                                            })}
                                        </select>
                                        <br />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div>
                                        <Input name="value2" step={0.0000000000000000001} value={this.props.unitConverterValues.value2} onChange={this.convertFunction} />
                                        <select value={this.props.unitConverterValues.unit2.name} id="unit2" name="unit2" className="form-control" onChange={this.changeUnit}>
                                            {this.props.unitConverterValues.unitsForType.map((unit, key) => {
                                                return (<option key={key} value={unit.name}>{unit.name}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    : null}
                <br />
            </Form>
        )
    }
}

UnitConverterForm.propTypes = {
    formToState: PropTypes.func,
    unitConverterValues: PropTypes.shape({
        value1: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        value2: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        unitType: PropTypes.string,
        unit1: PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
            type: PropTypes.string
        }),
        unit2: PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.number,
            type: PropTypes.string
        }),
        ready: PropTypes.bool,
        unitTypes: PropTypes.arrayOf(PropTypes.string),
        unitsForType: PropTypes.arrayOf(PropTypes.object)
    })
}